import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ForkRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fork_right"}/>
}
